import { clsx } from 'clsx'

interface YearSelectorProps {
  years: number[]
  value: number | 'cumulative'
  onChange: (value: number | 'cumulative') => void
  loading?: boolean
  disabled?: boolean
}

export function YearSelector({ years, value, onChange, loading = false, disabled = false }: YearSelectorProps) {
  const options: Array<{ label: string; value: number | 'cumulative' }> = [
    ...years.map(y => ({ label: String(y), value: y as number | 'cumulative' })),
    { label: 'Cumulativo', value: 'cumulative' },
  ]

  return (
    <div className="flex items-center gap-1 rounded-xl p-1 bg-[--km-surface-2] ring-1 ring-white/5">
      {options.map(opt => (
        <button
          key={String(opt.value)}
          onClick={() => onChange(opt.value)}
          disabled={loading || disabled}
          className={clsx(
            'px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150',
            'disabled:opacity-40 disabled:cursor-not-allowed',
            value === opt.value
              ? 'bg-indigo-600 text-white shadow-sm'
              : 'text-[--km-text-muted] hover:text-[--km-text-primary] hover:bg-white/5',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
